export const RESET_PASSWORD_FORM = 'resetPassword';
